import { createClient } from '@supabase/supabase-js'

// Supabase project credentials
// PRODUCTION: Replace these with environment variables on your server:
//   const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
//   const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY
const SUPABASE_URL = 'https://mrsxuvodwutnxmuopqmw.supabase.co'
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1yc3h1dm9kd3V0bnhtdW9wcW13Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUxNDk1MDEsImV4cCI6MjA5MDcyNTUwMX0.E_-uGuhLjDEyRTWX7DFg4ZMvN75-KIY7w0TSzV7lE10'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
